import { Workspace } from './Workspace';

export * from './Workspace';

export default Workspace;
